// Import ES6 Promise
import 'es6-promise/auto'

// Import System requirements
import Vue from 'vue'
import VueRouter from 'vue-router'

import { sync } from 'vuex-router-sync'
import routes from './routes'
import store from './store'
import config from './config'

// Import Helpers for filters
import { domain, count, prettyDate, pluralize, prettyTime, prettyDateTime, prettyNumber, prettyArray, age } from './filters'

// Import Views - Top level
import AppView from './components/App.vue'

import Paginate from 'vuejs-paginate'
import Uploader from 'vuejs-uploader'
import VueLodash from 'vue-lodash'
import axios from 'axios'

import Vuelidate from 'vuelidate'

import ConfirmModal from './components/views/ConfirmModal'
import LinkCaseModal from './components/views/LinkCaseModal'
import LinkTestimonyModal from './components/views/LinkTestimonyModal'
import NewCaseModal from './components/views/NewCaseModal'
import NewUserModal from './components/views/NewUserModal'
import SubscriptionModal from './components/views/SubscriptionModal'
import Timeline from './components/views/Timeline'
import AutomaticData from './components/views/AutomaticData'
import WeatherCard from './components/views/WeatherCard'
import Map from './components/views/Map'
import Injuries from './components/views/Injuries'
import TestimoniesList from './components/views/TestimoniesList'
import UsersList from './components/views/UsersList'
// import Tweet from 'vue-tweet-embed'
import Anchors from './components/views/Anchors'
import Signaletics from './components/views/Signaletics'
import TagsSearch from './components/views/TagsSearch'
import Datepicker from 'vuejs-datepicker'

Vue.component('paginate', Paginate)
Vue.component('confirm-modal', ConfirmModal)
Vue.component('link-case-modal', LinkCaseModal)
Vue.component('link-testimony-modal', LinkTestimonyModal)
Vue.component('new-case-modal', NewCaseModal)
Vue.component('new-user-modal', NewUserModal)
Vue.component('new-subscription-modal', SubscriptionModal)
Vue.component('timeline', Timeline)
// Vue.component('tweet', Tweet)
Vue.component('automatic-data', AutomaticData)
Vue.component('weather-card', WeatherCard)
Vue.component('osm-map', Map)
Vue.component('injuries', Injuries)
Vue.component('testimonies-list', TestimoniesList)
Vue.component('users-list', UsersList)
Vue.component('uploader', Uploader)
Vue.component('anchors', Anchors)
Vue.component('signaletics', Signaletics)
Vue.component('tagsSearch', TagsSearch)
Vue.component('datepicker', Datepicker)

// Import Install and register helper items
Vue.filter('count', count)
Vue.filter('domain', domain)
Vue.filter('prettyDate', prettyDate)
Vue.filter('prettyDateTime', prettyDateTime)
Vue.filter('prettyTime', prettyTime)
Vue.filter('prettyNumber', prettyNumber)
Vue.filter('prettyArray', prettyArray)
Vue.filter('pluralize', pluralize)
Vue.filter('age', age)

Vue.use(VueRouter)
Vue.use(Vuelidate)
Vue.use(VueLodash)

import VueNativeSock from 'vue-native-websocket'

// Routing logic
var router = new VueRouter({
  routes: routes,
  mode: 'history',
  linkExactActiveClass: 'active',
  scrollBehavior: function (to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 }
  }
})

// Some middleware to help us ensure the user is authenticated.
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth) && (!window.localStorage.getItem('token') || window.localStorage.getItem('token') === 'null')) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    window.console.log('Not authenticated')
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  } else {
    Vue.use(VueNativeSock, config.webSocketServer + '?token=' + window.localStorage.getItem('token'))
    next()
  }
})

sync(store, router)

// Check local storage to handle refreshes
if (window.localStorage) {
  var localUserString = window.localStorage.getItem('user') || 'null'
  var localUser = JSON.parse(localUserString)

  if (localUser && store.state.user !== localUser) {
    store.commit('SET_USER', localUser)
    store.commit('SET_TOKEN', window.localStorage.getItem('token'))
  }
}

// add api interceptor to redirect to login page when user has 401 response
axios.interceptors.response.use(function (response) {
  // Do something with response data
  return response
}, function (error) {
  // Do something with response error
  if (error.response && error.response.status === 401) {
    router.push({
      path: '/login'
    })
  }
  return Promise.reject(error)
})

// Start out app!
// eslint-disable-next-line no-new
new Vue({
  el: '#root',
  router: router,
  store: store,
  render: h => h(AppView)
})



// WEBPACK FOOTER //
// ./src/main.js